module.exports = __webpack_public_path__ + "static/media/checkbox-off.99ae3d6e.svg";